import { render, staticRenderFns } from "./UPUsers.vue?vue&type=template&id=0b4205ab"
import script from "./UPUsers.vue?vue&type=script&lang=js"
export * from "./UPUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports